import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/toaster";
import { AtestProvider } from "./components/AtestProvider";

function App() {
  useEffect(() => {
    document.title = "Elorte-Medarić d.o.o. – PVC elektro ormari & logistika";
  }, []);

  return (
    <div className="App bg-white text-neutral-900">
      <AtestProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="proizvodi" element={<Products />} />
              <Route path="kontakt" element={<Contact />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AtestProvider>
    </div>
  );
}

export default App;
